(function () {
  angular.module("akitabox.desktop.building.detail", [
    "akitabox.ui.components.dashboard",
  ]);
})();
